export const nav = {
  get: {
    name: "我收到的通知",
    status: "get",
    routerName: 'GetNotice'
  },
  send: {
    name: "我发送的通知",
    status: "send",
    routerName: 'SendNotice'
  },
  all: {
    name: "全部通知",
    status: "other",
    routerName: 'OtherNotice'
  }
}

export const usersList = [
  {key: '机构管理员', value: 'organ'},
  {key: '讲师', value: 'teacher'},
  {key: '学员', value: 'student'},
]